<template>
	<div class="chat-message-item" :class="active ? 'active' : ''">
		<div class="message-tip" v-if="message.type == $enums.MESSAGE_TYPE.TIP_TEXT">
			{{ message.content }}
		</div>
		<div class="message-tip" v-else-if="message.type == $enums.MESSAGE_TYPE.TIP_TIME">
			{{ $date.toTimeText(message.sendTime) }}
		</div>
		<div class="message-normal" v-else-if="isNormal" :class="{ 'message-mine': mine }">
			<div class="head-image">
				<head-image :name="showName" :size="38" :url="headImage" :id="message.sendId"></head-image>
			</div>
			<div class="content">
				<div v-show="mode == 1 && message.groupId && !message.selfSend" class="message-top">
					<span>{{ showName }}</span>
				</div>
				<div v-show="mode == 2" class="message-top">
					<span>{{ showName }}</span>
					<span>{{ $date.toTimeText(message.sendTime) }}</span>
				</div>
				<div class="message-bottom" @contextmenu.prevent="showRightMenu($event)">
					<div ref="chatMsgBox" class="message-content-wrapper">
						<span class="message-text" v-if="isTextMessage" v-html="htmlText"></span>
						<div class="message-image" v-else-if="message.type == $enums.MESSAGE_TYPE.IMAGE"
							@click="showFullImageBox()">
							<img :style="imageStyle" :src="contentData.thumbUrl" loading="lazy" />
						</div>
						<div class="message-file" v-else-if="message.type == $enums.MESSAGE_TYPE.FILE">
							<div class="chat-file-box" v-loading="sending">
								<div class="chat-file-info">
									<el-link class="chat-file-name" :underline="true" target="_blank" type="primary"
										:href="contentData.url" :download="contentData.name">{{ contentData.name
										}}</el-link>
									<div class="chat-file-size">{{ fileSize }}</div>
								</div>
								<div class="chat-file-icon">
									<span type="primary" class="el-icon-document"></span>
								</div>
							</div>
						</div>
						<div class="message-voice" v-else-if="message.type == $enums.MESSAGE_TYPE.AUDIO"
							@click="onPlayVoice()">
							<audio controls :src="JSON.parse(message.content).url"></audio>
						</div>
						<div title="发送中" v-if="sending" class="sending" v-loading="'true'"></div>
						<div title="发送失败" v-else-if="sendFail" @click="onSendFail" class="send-fail el-icon-warning">
						</div>
					</div>
					<div class="chat-action message-text" v-if="isAction">
						<span v-if="message.type == $enums.MESSAGE_TYPE.ACT_RT_VOICE" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-voice"></span>
						<span v-if="message.type == $enums.MESSAGE_TYPE.ACT_RT_VIDEO" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-video"></span>
						<span>{{ message.content }}</span>
					</div>
					<div class="message-status" v-if="!isAction && message.selfSend && !isGroupMessage">
						<span class="chat-readed" v-if="isReaded">已读</span>
						<span class="chat-unread" v-else>未读</span>
					</div>
					<div class="chat-receipt" v-show="message.receipt && message.selfSend" @click="onShowReadedBox">
						<span v-if="message.receiptOk" class="icon iconfont icon-ok" title="全体已读"></span>
						<span v-else>{{ message.readedCount }}人已读</span>
					</div>
				</div>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
		<chat-group-readed ref="chatGroupReadedBox" :message="message" :group="group"></chat-group-readed>
	</div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
import RightMenu from '../common/RightMenu.vue';
import ChatGroupReaded from './ChatGroupReaded.vue';
export default {
	name: "messageItem",
	components: {
		HeadImage,
		RightMenu,
		ChatGroupReaded
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		mode: {
			type: Number,
			default: 1
		},
		mine: {
			type: Boolean,
			required: true
		},
		headImage: {
			type: String,
			required: true
		},
		showName: {
			type: String,
			required: true
		},
		conversation: {
			type: Object,
			required: true
		},
		group: {
			type: Object,
		},
		message: {
			type: Object,
			required: true
		},
		menu: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			audioPlayState: 'STOP'
		}
	},
	methods: {
		onSendFail() {
			this.$emit("resend", this.message);
		},
		showFullImageBox() {
			let imageUrl = JSON.parse(this.message.content).originUrl;
			if (imageUrl) {
				this.$eventBus.$emit("openFullImage", imageUrl);
			}
		},
		onPlayVoice() {
			if (!this.audio) {
				this.audio = new Audio();
			}
			this.audio.src = JSON.parse(this.message.content).url;
			this.audio.play();
			this.onPlayVoice = 'RUNNING';
		},
		showRightMenu(e) {
			this.$refs.rightMenu.open(e, this.menuItems);
		},
		onSelectMenu(item) {
			this.$emit(item.key.toLowerCase(), this.message);
		},
		onShowReadedBox() {
			let rect = this.$refs.chatMsgBox.getBoundingClientRect();
			this.$refs.chatGroupReadedBox.open(rect);
		}
	},
	computed: {
		sending() {
			return this.message.status == this.$enums.MESSAGE_STATUS.SENDING;
		},
		sendFail() {
			return this.message.status == this.$enums.MESSAGE_STATUS.FAILED;
		},
		contentData() {
			return JSON.parse(this.message.content)
		},
		fileSize() {
			let size = this.contentData.size;
			if (size > 1024 * 1024) {
				return Math.round(size / 1024 / 1024) + "M";
			}
			if (size > 1024) {
				return Math.round(size / 1024) + "KB";
			}
			return size + "B";
		},
		menuItems() {
			let items = [];
			if (this.isTextMessage) {
				items.push({
					key: 'COPY',
					name: '复制'
				});
			}
			items.push({
				key: 'DELETE',
				name: '删除',
				danger: true
			});
			if (this.message.selfSend && this.message.id > 0) {
				items.push({
					key: 'RECALL',
					name: '撤回'
				});
			}
			return items;
		},
		isTextMessage() {
			return this.message.type == this.$enums.MESSAGE_TYPE.TEXT
		},
		isAction() {
			return this.$msgType.isAction(this.message.type);
		},
		isNormal() {
			const type = this.message.type;
			return this.$msgType.isNormal(type) || this.$msgType.isAction(type)
		},
		isReaded() {
			return this.message.status == this.$enums.MESSAGE_STATUS.READED || this.conversation.maxReadedId >= this.message.id
		},
		htmlText() {
			let color = this.message.selfSend ? 'white' : '';
			let text = this.$str.html2Escape(this.message.content)
			text = this.$url.replaceURLWithHTMLLinks(text, color)
			return this.$emo.transform(text, 'emoji-normal')
		},
		isGroupMessage() {
			return !!this.message.groupId;
		},
		imageStyle() {
			// 计算图片的显示宽高，要求：任意边不能高于360px,不能低于60px,不能拉伸图片比例
			let maxSize = this.configStore.fullScreen ? 360 : 240;
			let minSize = 60;
			let width = this.contentData.width;
			let height = this.contentData.height;
			if (width && height) {
				let ratio = Math.min(width, height) / Math.max(width, height);
				let w = Math.max(Math.min(width > height ? maxSize : ratio * maxSize, width), minSize);
				let h = Math.max(Math.min(width > height ? ratio * maxSize : maxSize, height), minSize);
				return `width: ${w}px;height:${h}px;object-fit: cover;`
			} else {
				// 兼容历史版本，历史数据没有记录宽高
				return `max-width: ${maxSize}px;min-width:60px;max-height: ${maxSize}px;min-height:60px;`
			}
		}
	}
}
</script>

<style lang="scss">
.chat-message-item {
	padding: 4px 16px;
	border-radius: var(--im-radius, 4px);
	transition: background-color 0.15s ease;

	&.active {
		background: rgba(7, 193, 96, 0.08);
	}

	&:hover {
		background: var(--im-background-active);
	}

	.message-tip {
		line-height: 44px;
		font-size: var(--im-font-size-small);
		color: #b2b2b2;
		text-align: center;
	}

	.message-normal {
		position: relative;
		font-size: 0;
		padding-left: 50px;
		min-height: 44px;
		margin-top: 12px;

		.head-image {
			position: absolute;
			width: 40px;
			height: 40px;
			top: 0;
			left: 0;
		}

		.content {
			text-align: left;
			display: flex;
			flex-direction: column;
			align-items: flex-start;

			.message-top {
				display: flex;
				flex-wrap: nowrap;
				color: var(--im-text-color-light);
				font-size: var(--im-font-size-small);
				line-height: 20px;
				margin-bottom: 2px;
				padding: 0 4px;

				span {
					margin-right: 12px;
				}
			}

			.message-bottom {
				display: flex;
				align-items: flex-end;
				width: 100%;
				min-height: 26px;
				padding: 0 4px;

				.message-content-wrapper {
					position: relative;
					display: flex;
					align-items: flex-end;
					max-width: 60%;
					min-width: 40px;

					.sending {
						width: 25px;
						height: 25px;
						margin: 0 5px;

						.circular {
							width: 25px;
							height: 25px;
						}
					}

					.send-fail {
						color: #e45050;
						font-size: 30px;
						cursor: pointer;
						margin: 0 5px;
					}
				}

				.message-text {
					position: relative;
					display: inline-block;
					line-height: 22px;
					padding: 7px 11px;
					background-color: var(--im-bubble-other);
					border-radius: 4px;
					font-size: var(--im-font-size);
					text-align: left;
					white-space: pre-wrap;
					word-break: break-word;
					color: var(--im-text-color);
					max-width: 100%;
					min-height: 22px;
					box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);

					a {
						color: #576b95 !important;
					}

					// 微信式气泡左尖角
					&::before {
						content: "";
						position: absolute;
						left: -5px;
						top: 12px;
						width: 0;
						height: 0;
						border-top: 5px solid transparent;
						border-bottom: 5px solid transparent;
						border-right: 5px solid var(--im-bubble-other);
					}
				}

				.message-image {
					position: relative;
					border-radius: 4px;
					overflow: hidden;
					cursor: pointer;
					background: var(--im-bubble-other);
					max-width: 240px;
					box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);

					img {
						display: block;
					}

					// 微信式气泡左尖角
					&::before {
						content: "";
						position: absolute;
						left: -5px;
						top: 12px;
						width: 0;
						height: 0;
						border-top: 5px solid transparent;
						border-bottom: 5px solid transparent;
						border-right: 5px solid var(--im-bubble-other);
						z-index: 1;
					}
				}

				.message-file {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					cursor: pointer;
					margin-bottom: 2px;

					.chat-file-box {
						display: flex;
						flex-wrap: nowrap;
						align-items: center;
						min-height: 60px;
						min-width: 240px;
						max-width: 320px;
						background: var(--im-bubble-other);
						border-radius: 4px;
						padding: 12px 16px;
						box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);
						position: relative;

						// 微信式气泡左尖角
						&::before {
							content: "";
							position: absolute;
							left: -5px;
							top: 12px;
							width: 0;
							height: 0;
							border-top: 5px solid transparent;
							border-bottom: 5px solid transparent;
							border-right: 5px solid var(--im-bubble-other);
						}

						.chat-file-info {
							flex: 1;
							height: 100%;
							text-align: left;
							font-size: 14px;
							margin-right: 10px;
							overflow: hidden;

							.chat-file-name {
								display: inline-block;
								min-width: 160px;
								max-width: 220px;
								font-size: 14px;
								margin-bottom: 4px;
								white-space: pre-wrap;
								word-break: break-all;
								color: var(--im-text-color);
							}

							.chat-file-size {
								font-size: 12px;
								color: var(--im-text-color-light);
							}
						}

						.chat-file-icon {
							font-size: 40px;
							color: #5b6e8c;
							flex-shrink: 0;
						}
					}

					.send-fail {
						color: #e60c0c;
						font-size: 30px;
						cursor: pointer;
						margin: 0 20px;
					}

				}

				.message-voice {
					font-size: 14px;
					cursor: pointer;

					audio {
						height: 45px;
						padding: 5px 0;
					}
				}

				.chat-action {
					display: flex;
					align-items: center;
					padding: 6px 10px;
					background: var(--im-bubble-other);
					border-radius: 4px;
					position: relative;
					box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);

					&::before {
						content: "";
						position: absolute;
						left: -5px;
						top: 12px;
						width: 0;
						height: 0;
						border-top: 5px solid transparent;
						border-bottom: 5px solid transparent;
						border-right: 5px solid var(--im-bubble-other);
					}

					.iconfont {
						cursor: pointer;
						font-size: 22px;
						padding-right: 8px;
					}
				}

				.message-status {
					margin-top: 4px;
					display: block;
					padding: 0 4px;

					.chat-readed {
						font-size: 11px;
						color: var(--im-text-color-light);
					}

					.chat-unread {
						font-size: 11px;
						color: var(--im-color-danger);
					}
				}

				.chat-receipt {
					font-size: 11px;
					cursor: pointer;
					color: var(--im-text-color-light);
					margin-top: 4px;
					padding: 0 4px;

					.icon-ok {
						font-size: 14px;
						color: var(--im-color-success);
					}
				}

				.chat-at-user {
					padding: 1px 4px;
					border-radius: 2px;
					cursor: pointer;
					background: rgba(7, 193, 96, 0.1);
					color: var(--im-color-primary);
				}
			}
		}


		&.message-mine {
			text-align: right;
			padding-left: 0;
			padding-right: 50px;

			.head-image {
				left: auto;
				right: 0;
			}

			.content {
				text-align: right;
				align-items: flex-end;

				.message-top {
					flex-direction: row-reverse;

					span {
						margin-left: 12px;
						margin-right: 0;
					}
				}

				.message-bottom {
					flex-direction: row-reverse;

					.message-content-wrapper {
						flex-direction: row-reverse;
						max-width: 60%;
					}

					.message-text {
						background-color: var(--im-bubble-mine);

						// 我的气泡：右侧尖角
						&::before {
							left: auto;
							right: -5px;
							border-right: none;
							border-left: 5px solid var(--im-bubble-mine);
						}
					}

					.message-image {
						&::before {
							left: auto;
							right: -5px;
							border-right: none;
							border-left: 5px solid var(--im-bubble-other);
						}
					}

					.chat-file-box {
						&::before {
							left: auto;
							right: -5px;
							border-right: none;
							border-left: 5px solid var(--im-bubble-other);
						}
					}

					.chat-action {
						flex-direction: row-reverse;
						background-color: var(--im-bubble-mine);

						&::before {
							left: auto;
							right: -5px;
							border-right: none;
							border-left: 5px solid var(--im-bubble-mine);
						}

						.iconfont {
							transform: rotateY(180deg);
							padding-right: 0;
							padding-left: 8px;
						}
					}
				}
			}
		}

	}
}
</style>